import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosPromise } from '../../../utils/axios.promise';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import { CommonConfig } from '../../../configs/config.common';

@Component
export default class CreateMonerisOrder extends Vue {
    public title: string = 'CreateMonerisOrder';
    public orderInfo: any = {};
    public transId: any = null;
    @Prop({ default: null })
    public fjjUserId: any;

    @Prop({ default: null })
    public insId: any;

    public email: any = null;
    public configs = new CommonConfig();
    public async timeout(ms: number): Promise<any> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public userInfoDelegate = new UserInfoDelegate();

    @Watch('fjjUserId', { immediate: true, deep: true })
    public async onUserIdChanged(val: any, oldVal: any) {
        const fjjUserId = val;
        if (fjjUserId) {
            this.fjjUserId = fjjUserId;
            const userInfo = await this.userInfoDelegate.getUserInfo(this.fjjUserId);
            this.email = userInfo.uEmail;
        }
    }
    public async monerisSubmit() {
        if (!this.insId) {
            console.log('no coupon instance id');
            return;
        }
        const fetched = await AxiosPromise.postUrlEncode(`${this.configs.tradeService}/order/add`, {
            body: JSON.stringify(
                {
                    clientId: this.fjjUserId,
                    clientType: 'C',
                    itemList: [{
                        'itemId': this.insId,
                        'itemType': 'coupon',
                        'quantity': 1
                    }]
                }
            )
        });
        if (fetched.status === 200) {
            if (fetched.data.errorCode === 200) {
                const data = fetched.data.data;
                const orderId = data.order_id;
                if (orderId) {
                    this.orderInfo = data;
                    const transRes = await AxiosPromise.postUrlEncode(`${this.configs.tradeService}/transaction/add`, {
                        orderId: orderId
                    });
                    if (transRes.status === 200) {
                        if (transRes.data.errorCode === 200) {
                            this.transId = transRes.data.data.xTransSn;
                            await this.timeout(500);
                            if (this.orderInfo.subtotal1 > 0 ) {
                                (this.$refs.purchase_form as any).submit();
                            }
                        }
                    }
                }
                return data;
            }
        }
        return true;
    }
}
